module.exports = __webpack_public_path__ + "static/media/jcb.2a82975f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/jcb.svg
// module id = 653
// module chunks = 0